<template>
  <div class="mx-0 my-0 px-0 py-0">
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />

    <div class="border-0 mx-auto container-xl">
      <div class="title-area">
        <h1 class="page-title h2 mb-2">Frequently asked questions</h1>
      </div>

      <b-tabs
        class=""
        pills
        card
        vertical
        nav-wrapper-class="col-3 mr-3"
      >
        <b-tab
          v-if="topfaqs.length > 0"
          title="Most read"
          class="pt-0 mt-0"
        >
          <template #title>
            <b-icon
              icon="star"
              class="mr-2 pt-0 pb-1 mt-0"
            />Most read
          </template>
          <div
            class="accordion"
            role="tablist"
          >
            <b-card
              v-for="faq in topfaqs"
              :key="faq.id"
              no-body
              class="mb-1 border-0 px-0"
            >
              <b-card-header
                header-tag="header"
                class="p-0 border-0 bg-white"
                role="tab"
              >
                <b-button
                  :id="faq.id"
                  v-b-toggle="'accordion-'+faq.id"
                  block
                  href="#"
                  variant="info"
                  class="text-left px-3"
                  @click="addcount"
                >
                  <b-icon
                    icon="plus-circle-fill"
                    class="fade-in-text when-closed mr-2"
                    font-weight="300"
                  />
                  <b-icon
                    icon="plus-circle-"
                    class="when-opened mr-2"
                    font-weight="300"
                  />
                  <span style="font-size: 18px !important">{{ faq.faq_heading }}</span>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="'accordion-'+faq.id"
                class="col-12"
                accordion="my-accordion"
                role="tabpanel"
                @show="addcount(faq.id)"
                >
                <b-card-body
                  class="border-0"
                >
                  <b-card-text>
                    <span style="font-weight: 200;" v-html="faq.faq_text" />
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-tab>
        <b-tab
          v-for="(thefaqs, cat) in groupedfaqs"
          :key="cat"
          class="pt-0 mt-0"
          :title="gettitle(cat)"
        >
          <div
            class="accordion"
            role="tablist"
          >
            <b-card
              v-for="faq in thefaqs"
              :key="faq.id"
              no-body
              class="mb-1 border-0 px-0"
            >
              <b-card-header
                header-tag="header"
                class="p-1 border-0 bg-white"
                role="tab"
              >
                <b-btn
                  :id="faq.id"
                  v-b-toggle="'accordion-'+faq.id"
                  block
                  href="#"
                  variant="info"
                  class="text-left px-3"
                >
                  <b-icon
                    icon="plus-circle-fill"
                    class="fade-in-text when-closed mr-2"
                    font-weight="300"
                  />
                  <b-icon
                    icon="plus-circle-"
                    class="when-opened mr-2"
                    font-weight="300"
                  />
                  <span style="font-size: 18px !important">{{ faq.faq_heading }}</span>
                </b-btn>
              </b-card-header>
              <b-collapse
                :id="'accordion-'+faq.id"
                class="col-12"
                accordion="my-accordion"
                role="tabpanel"
                @show="addcount(faq.id)"
              >
                <b-card-body
                  class="border-0"
                >
                  <b-card-text>
                    <span style="font-weight: 200;" v-html="faq.faq_text" />
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import Breadcrumb from './Breadcrumb.vue'
import Navbar from './Navbar.vue'

function groupByKey (xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

export default {
  components: {
    Navbar,
    Breadcrumb
  },
  data () {
    return {
      faqcategories: [],
      groupedfaqs: [],
      topfaqs: [],
      counts: [],
      opentab: 0
    }
  },
  created () {
    this.faqs_get()
  },
  methods: {
    gettitle (cat) {
      const fcat =
        this.faqcategories.filter(f => f.sequence_number == cat).length
          ? this.faqcategories.filter(f => f.sequence_number == cat)[0].faqcategory_name
          : '- No category -'
      return fcat
    },
    faqs_get () {
      this.$store.dispatch('records_readall', { table_name: 'g_faqcategories ' })
        .then((resp) => {
          this.faqcategories = resp.data.result
          this.$store.dispatch('record_readlist', { table_name: 'g_faq', orderby: 'sequence_number' })
            .then((resp) => {
              const faqs = resp.data.result.map(
                (r) => {
                  return {
                    ...r,
                    faqcategory_id: r.faqcategory_id ? r.faqcategory_id : '- No category -',
                    faqcategory_sequence:
                        this.faqcategories.filter(f => f.faqcategory_name == r.faqcategory_id).length
                          ? this.faqcategories.filter(f => f.faqcategory_name == r.faqcategory_id)[0].sequence_number
                          : 0
                  }
                })
              const topfaqs = faqs.filter(f => f.number_reads > 0)
              topfaqs.sort((a, b) => (a.number_reads < b.number_reads) ? 1 : -1)
              this.topfaqs = topfaqs.slice(0, 10)
              const groupedfaqs = groupByKey(faqs, 'faqcategory_sequence')
              const sortedfaqs = Object.keys(groupedfaqs).sort().reduce(
                (obj, key) => {
                  obj[key] = groupedfaqs[key]
                  return obj
                },
                {}
              )
              this.groupedfaqs = sortedfaqs
            })
        })
    },
    addcount (faq_id) {
      if (!this.counts[faq_id]) {
        this.counts[faq_id] = 1
        this.$store.dispatch('record_read', { table_name: 'g_faq', id: faq_id })
          .then((resp) => {
            const number_reads = resp.data.number_reads + 1
            this.savefield('g_faq', faq_id, 'number_reads', number_reads)
          })
      }
    },
    savefield (tablename, id, fieldname, value) {
      if (id > 0) {
        var record = {
          id: id,
          [fieldname]: value
        }
        this.$store.dispatch('field_save', { tablename: tablename, record: record })
      }
    }
  }
}
</script>
<style scoped>
/* OLD CSS */
/*.btn-info {
    border: none !important;
    background: #007d8f !important;
    color: white;
    margin: 0 !important;
}*/
/* .btn-info:focus {
  border-color: white !important;
  border: none !important;
  outline: none !important;
} */
.show {
  transition: width 0.5s, height 0.5s, transform 0.5s;
}
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
    display: none;
}
.fade-in-text {
  animation: fadeIn 1s;
}
@keyframes fadeIn {
  0% { opacity: 1; }
  100% { opacity: 1; }
}
.collapsing {
    -webkit-transition: none;
    transition: none;
    visibility: hidden;
}

.collapse.show {
    -webkit-transition: none;
    transition: none;
    visibility: visible;
}
</style>
